const forgottenPassword = {
  forgotPassword: 'Forgot Password',
  enterEmail: 'Enter the email address you registered with here. If you have an account, we will send you a link to change your password.',
  successAlert: 'Thank you! We\'ve sent an email to your inbox. This contains a link that you must click to reset your password.',
  pleaseNote: 'Please note:',
  everyTwoHours: 'You can only request a new password once every 2 hours.',
  checkSpam: 'If you haven\'t received an email, please check your spam folder.',
  errorAlert: 'Too many password reset requests. You can request a new password every 2 hours. Please try again later.',
  email: 'email address',
  resetPassword: 'Reset password',
  enterNewPassword: 'Enter your new password here. We\'ll ask for this password when you sign in again.',
  newPassword: 'New password',
  repeatPassword: 'Confirm new password',
  back: 'Back',
  changePassword: 'change password',
  characterValidations: 'Password must be at least 8 characters long and contain 1 uppercase letter, 1 lowercase letter and 1 number',
  notice: 'Notice:',
  currentPasswordEmpty: 'Password cannot be empty.',
  newPasswordEmpty: 'New password cannot be empty.',
  eightCharacters: 'The password must be at least 8 characters long.',
  userNotFound: 'There is no customer account for the email address.',
  invalidCurrentPassword: 'The current password is incorrect.',
  passwordsNotEqual: 'New passwords do not match.',
  minSpecialCharacter: 'The password must contain at least 1 special character.',
  passwordChanged: 'The password has been changed.',
  samePasswords: 'The new password must not correspond to the old password.',
}

export default forgottenPassword
